import axiosInstance from "../utils/axios-instance";
import { actionCreator, createRequestTypes } from "../utils/helpers";
import { httpGetAndDispatchAction, httpPatchAndDispatchAction, httpPostAndDispatchAction } from "./_utils";

export const PAYMENT_PROVIDER_FIND_CURRENT_PROVIDER_ID = createRequestTypes('@paymentProvider/FIND_CURRENT_PROVIDER_ID');
export const PAYMENT_PROVIDER_FIND_ALL_IDS = createRequestTypes('@paymentProvider/FIND_ALL_IDS');
export const PAYMENT_PROVIDER_FIND_PROVIDER = createRequestTypes('@paymentProvider/FIND_PROVIDER');
export const PAYMENT_PROVIDER_PATCH_PROVIDER = createRequestTypes('@paymentProvider/PATCH_PROVIDER');
export const PAYMENT_PROVIDER_FIND_ALL = createRequestTypes('@paymentProvider/FIND_ALL');
export const CAN_MANAGE_PAYMENT_METHODS = createRequestTypes('CAN_MANAGE_PAYMENT_METHODS')
export const CAN_DO_ONE_TIME_PAYMENTS = createRequestTypes('CAN_DO_ONE_TIME_PAYMENTS')
export const PAYMENT_PROVIDER_TEST_PROVIDER = createRequestTypes("@paymentProvider/TEST_PROVIDER");

export const getCurrentPaymentProviderId = () =>
  httpGetAndDispatchAction(PAYMENT_PROVIDER_FIND_CURRENT_PROVIDER_ID, `/payment-provider/current/id`, "id");
export const clearCurrentPaymentProviderId = () => (dispatch) => { dispatch(actionCreator.empty(PAYMENT_PROVIDER_FIND_CURRENT_PROVIDER_ID)); }

export const findProviderIds = () =>
  httpGetAndDispatchAction(PAYMENT_PROVIDER_FIND_ALL_IDS, `/payment-providers/id`, "ids");
export const clearProviderIds = () => (dispatch) => { dispatch(actionCreator.empty(PAYMENT_PROVIDER_FIND_ALL_IDS)); }

export const getPaymentProviderById = (providerId) =>
  httpGetAndDispatchAction(PAYMENT_PROVIDER_FIND_PROVIDER, `/payment-provider/${providerId}`);
export const clearPaymentProviderById = (providerId) => (dispatch) => {
  dispatch(actionCreator.empty(PAYMENT_PROVIDER_FIND_PROVIDER), providerId);
};

export const clearPaymentProviders = () => (dispatch) => { dispatch(actionCreator.empty(PAYMENT_PROVIDER_FIND_ALL)); }

export const patchPaymentProvider = (providerId, providerPatch, setCurrent = true) =>
  httpPatchAndDispatchAction(
    PAYMENT_PROVIDER_PATCH_PROVIDER,
    `/payment-provider/${providerId}?setCurrent=${setCurrent ? "true" : "false"}`,
    providerPatch
  );

export const testPaymentProvider = (providerId, providerConfigurations) =>
  httpPostAndDispatchAction(
    PAYMENT_PROVIDER_TEST_PROVIDER,
    `/payment-provider/${providerId}/test`,
    providerConfigurations
  );

export const getCurrentPaymentProviderSupportsPaymentMethodStorage = () => async (dispatch) => {
  dispatch(actionCreator.request(CAN_MANAGE_PAYMENT_METHODS));
  try {
    const response = await axiosInstance.get(`/payment-provider/current/supports-payment-method-storage`);
    dispatch(actionCreator.success(CAN_MANAGE_PAYMENT_METHODS, response.data));
    return response;
  } catch (err) {
    dispatch(actionCreator.failure(CAN_MANAGE_PAYMENT_METHODS));

    throw err;
  }
};

export const getCurrentPaymentProviderSupportsOneTimePayment = () => async (dispatch) => {
  dispatch(actionCreator.request(CAN_DO_ONE_TIME_PAYMENTS));
  try {
    const response = await axiosInstance.get(`/payment-provider/current/supports-one-time-payment`);
    dispatch(actionCreator.success(CAN_DO_ONE_TIME_PAYMENTS, response.data));
    return response;
  } catch (err) {
    dispatch(actionCreator.failure(CAN_DO_ONE_TIME_PAYMENTS));

    throw err;
  }
};
